import { WithModal, withModal } from "Components/General/Modal/withModal";
import { I18N_NS } from "Config/i18n";
import { ActionButtonProps, MultiActionsMenu } from "Pages/Project/Documents/Components/MultiActionsMenu";
import { useTranslation } from "react-i18next";
import { FiltersModal } from "./FiltersModal";
import { InboxesModal } from "./InboxesModal";
import { RulesModal } from "./RulesModal";
// import { emailSendModal } from '../../utils/emailModalProps';

interface EmailInboxAdminToolsProps extends WithModal {}

export const EmailInboxAdminTools = withModal(({ showModal }: EmailInboxAdminToolsProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  const actionsConfig: ActionButtonProps[] = [
    {
      icon: "filter",
      label: t("Filters"),
      onClick: () =>
        showModal(FiltersModal, {
          modalProps: {
            title: t("Filters management"),
            footer: null,
            style: { maxWidth: 1200 },
            width: "100%",
            className: "full-height-modal with-drawer",
          },
        }),
    },
    {
      icon: "inbox",
      label: t("Inboxes"),
      onClick: () =>
        showModal(InboxesModal, {
          modalProps: {
            title: t("Inboxes management"),
            footer: null,
            style: { maxWidth: 1200 },
            width: "100%",
            className: "full-height-modal with-drawer",
          },
        }),
    },
    {
      icon: "equals",
      label: t("Rules"),
      onClick: () =>
        showModal(RulesModal, {
          modalProps: {
            title: t("Rules management"),
            footer: null,
            style: { maxWidth: 1200 },
            width: "100%",
            className: "full-height-modal with-drawer",
          },
        }),
    },
  ];

  return (
    <div style={{ marginLeft: 10 }}>
      <MultiActionsMenu actionsConfig={actionsConfig} />
    </div>
  );
});
